/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ supplier: NonNullable<unknown>, since: NonNullable<unknown> }} Inbound_Waiting_On_SupplierInputs */

const en_inbound_waiting_on_supplier = /** @type {(inputs: Inbound_Waiting_On_SupplierInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Waiting on ${i?.supplier} · submission · since ${i?.since}`)
};

/**
* | output |
* | --- |
* | "Waiting on {supplier} · submission · since {since}" |
*
* @param {Inbound_Waiting_On_SupplierInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbound_waiting_on_supplier = /** @type {((inputs: Inbound_Waiting_On_SupplierInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbound_Waiting_On_SupplierInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_inbound_waiting_on_supplier(inputs)
});